export default () => ({
  opened: false,
  menu: 'mobile',
  open(event) {
    this.opened = true
    this.menu = typeof event.detail.menu !== 'undefined' && event.detail.menu ? event.detail.menu : 'mobile'

    const top = document.getElementById('sticky-header').getBoundingClientRect().height
    this.$el.style.top = `${top}px`
  },
  close(event) {
    this.opened = false
  },
  toggle(event) {
    if(this.opened === false) {
      this.open(event)
    } else {
      this.close(event)
    }
  }
})
